var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import snackbarBus from "@/snackbarBus";
import PlayerEventBus from "@/EventBuses/ThePlayerEventBus";
import _ from "lodash";
var ThePlayerControls = (function (_super) {
    __extends(ThePlayerControls, _super);
    function ThePlayerControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.player = _this.$store.state.player;
        return _this;
    }
    ThePlayerControls.prototype.play = function () {
        this.$store.dispatch("play");
    };
    ThePlayerControls.prototype.pause = function () {
        this.$store.dispatch("pause");
    };
    ThePlayerControls.prototype.toggleRepeat = function () {
        if (this.player.repeat === 2) {
            this.$store.dispatch('setRepeat', 0);
        }
        else {
            this.$store.dispatch('setRepeat', this.player.repeat + 1);
        }
    };
    Object.defineProperty(ThePlayerControls.prototype, "isPlaylingLast", {
        get: function () {
            if (!this.player.playlist)
                return false;
            return this.player.position === this.player.playlist.length - 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThePlayerControls.prototype, "canNext", {
        get: function () {
            if (!this.player.playlist.length)
                return false;
            return this.player.repeat === 2 || !this.isPlaylingLast;
        },
        enumerable: true,
        configurable: true
    });
    ThePlayerControls.prototype.playNext = function () {
        if (this.player.repeat === 2 && this.isPlaylingLast) {
            this.$store.dispatch("setPosition", 0);
        }
        else {
            this.$store.dispatch("setPosition", this.player.position + 1);
        }
    };
    ThePlayerControls.prototype.playPrevious = function () {
        if (this.player.position === 0) {
            PlayerEventBus.$emit("seekTo", 0);
        }
        else {
            this.$store.dispatch("setPosition", this.player.position - 1);
        }
    };
    ThePlayerControls.prototype.onRepeatChange = function (val) {
        if (val === 0) {
            snackbarBus.$emit("show", "Repeat is off");
        }
        else if (val === 1) {
            snackbarBus.$emit("show", "Repeat track is on");
        }
        else if (val === 2) {
            snackbarBus.$emit("show", "Loop playlist is on");
        }
    };
    ThePlayerControls.prototype.onShuffleChange = function (shuffle) {
        if (shuffle) {
            snackbarBus.$emit("show", "Playlist shuffled");
            var part1 = this.player.playlist.slice(0, this.player.position + 1);
            var part2 = this.player.playlist.slice(this.player.position + 1);
            var shuffled = _.shuffle(part2);
            this.$store.dispatch("setPlaylist", _.concat(part1, shuffled));
        }
    };
    __decorate([
        Watch("player.repeat"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ThePlayerControls.prototype, "onRepeatChange", null);
    __decorate([
        Watch("player.shuffle"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ThePlayerControls.prototype, "onShuffleChange", null);
    ThePlayerControls = __decorate([
        Component
    ], ThePlayerControls);
    return ThePlayerControls;
}(Vue));
export default ThePlayerControls;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/ThePlayer/ThePlayerControls.vue
// module id = 269
// module chunks = 0